<template>
  <Card>
    <template #title=""
      ><div class="p-d-flex p-justify-between">
        ระบุ Parameter อื่น ๆ

        <span>
          <Button
            @click="onSaveParameter"
            label="บันทึก"
            icon="pi pi-save"
            class="p-button-success"
          />
          <BackButton class="p-ml-2"></BackButton>
        </span>
      </div>
    </template>
    <template #content="">
      <div class="p-grid">
        <div class="p-col-4 p-text-right">
          Level ของพนักงานที่ไม่จำเป็นต้องอนุมัติ :
        </div>
        <div class="p-col-8 p-fluid">
          <InputNumber
            v-model="config.noApproverLevel"
            :max="10"
            :min="0"
            :showButtons="true"
          ></InputNumber>
        </div>
      </div>
    </template>
  </Card>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";
import { usePlugin } from "@/plugins";
import { AppParameterDto, UpsertAppParameterRequest } from "@/types";

export default defineComponent({
  name: "ConfigParameterScreen",
  setup() {
    const { axios, success, error, setLoading } = usePlugin();
    const config = ref<AppParameterDto>({
      noApproverLevel: 0,
    });

    const loadParameters = async () => {
      setLoading(true);
      try {
        const result = await axios.post<AppParameterDto>(
          "api/v1/services/configParameter/get"
        );
        success("ดึงข้อมูลสำเร็จแล้ว");
        config.value = result.data;
      } catch (e) {
        error(e);
      } finally {
        setLoading(false);
      }
    };

    const onSaveParameter = async () => {
      setLoading(true);
      try {
        await axios.post("api/v1/services/configParameter/upsert", {
          parameter: config.value,
        } as UpsertAppParameterRequest);
        success("บันทึกข้อมูลสำเร็จแล้ว");
        await loadParameters();
      } catch (e) {
        error(e);
      } finally {
        setLoading(false);
      }
    };

    onMounted(() => loadParameters());
    return {
      config,
      onSaveParameter,
    };
  },
});
</script>

<style></style>
